export default __webpack_public_path__ + "static/tooltip-critical-dont-light-a79582f0db2104cf84cc5fc1f7d5f832f1fd58cb17860c38d80586e538f88289.png";